import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	LifeCycle,
	PlatformEnvDataProviderSymbol,
	PlatformSymbol,
	PlatformViewportAPISym,
	PlatformWorkerPromiseSym,
	WixCodeSdkHandlersProviderSym,
	PlatformResetCompsSymbol,
	LivePreviewEnvDataSetterSymbol,
	ControllersInvokerSymbol,
	StoresProviderSymbol,
	SamePageUrlChangeListenerSymbol,
} from '@wix/thunderbolt-symbols'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { platformHandlersProvider } from '../handlers/platformHandlers'
import { platformViewportAPI } from '../handlers/viewportHandlers'
import * as platformEnvDataProviders from '../platformEnvData/platformEnvData'
import { dsLocationEnvDataProvider } from '../platformEnvData/locationEnvDataProvider'
import { biEnvDataProvider } from '../platformEnvData/biEnvDataProvider'
import { livePreviewEnvDataProvider } from '../platformEnvData/livePreviewEnvDataProvider'
import { Storage } from '../storage/storage'
import { platformDS } from './platform-ds'
import { WorkerIframeWrapperManagerSymbol, WorkerIframeWrapperManager } from './worker-iframe-wrapper/workerIframeWrapperManager'
import { platformSideEffectsHandlers } from './platformSideEffectsHandlers'
import { platformUrlManager } from '../handlers/platformUrlManager'
import { platformResetComps } from './platformResetComps'
import { platformControllersHandler } from './platformControllersHandler'
import { dsStoresSdkHandlersProvider } from '../handlers/storesSdkHandlersProvider'
import { unfinishedTasksHandlersProvider } from '../handlers/unfinishedTasksHandlersProvider'
import { PlatformAppWillLoadPage } from './platformAppWillLoadPage'

export const editor: ContainerModuleLoader = (bind) => {
	bind(PlatformViewportAPISym, LifeCycle.AppWillLoadPageHandler).to(platformViewportAPI)
	bind(WixCodeSdkHandlersProviderSym).to(platformHandlersProvider)
	bind(WixCodeSdkHandlersProviderSym, StoresProviderSymbol).to(dsStoresSdkHandlersProvider)
	bind(LifeCycle.AppWillLoadPageHandler).to(PlatformAppWillLoadPage)
	bind(PlatformSymbol, LifeCycle.AppWillUnmountHandler).to(platformDS)
	bind(WorkerIframeWrapperManagerSymbol, PlatformWorkerPromiseSym).to(WorkerIframeWrapperManager)
	bind(PlatformResetCompsSymbol).to(platformResetComps)
	bind(PlatformEnvDataProviderSymbol).to(biEnvDataProvider)
	bind(PlatformEnvDataProviderSymbol).to(dsLocationEnvDataProvider)
	bind(WixCodeSdkHandlersProviderSym, PlatformEnvDataProviderSymbol).to(Storage)
	bind(WixCodeSdkHandlersProviderSym).to(unfinishedTasksHandlersProvider)
	bind(LivePreviewEnvDataSetterSymbol, PlatformEnvDataProviderSymbol, LifeCycle.AppWillLoadPageHandler).to(livePreviewEnvDataProvider)
	bind(ModelUpdatesHandlersImplementor).to(platformSideEffectsHandlers)
	bind(ControllersInvokerSymbol, WixCodeSdkHandlersProviderSym, LifeCycle.AppWillLoadPageHandler).to(platformControllersHandler)
	bind(WixCodeSdkHandlersProviderSym, SamePageUrlChangeListenerSymbol).to(platformUrlManager)
	Object.values(platformEnvDataProviders).forEach((envDataProvider) => {
		bind(PlatformEnvDataProviderSymbol).to(envDataProvider)
	})
}
